// Focus on body/nothing is the list's to reclaim; any real element outside it is where the user put the caret.
export const hasFocusOutsideList = (list: HTMLElement | null): boolean => {
  if (!list) return false;
  const active: Element | null = document.activeElement;
  if (!active || active === document.body) return false;
  return !list.contains(active);
};
